import { createContext } from 'react';

var TabsContext = /*#__PURE__*/createContext({
  activeIndex: 0,
  setActiveIndex: function setActiveIndex() {},
  selectedIndex: 0,
  setSelectedIndex: function setSelectedIndex() {}
});
var TabsContext$1 = TabsContext;

export { TabsContext$1 as default };
//# sourceMappingURL=TabsContext.js.map
